import { Calendar, CalendarProps } from 'primereact/calendar';
import { useFormContext, Controller, UseControllerProps } from 'react-hook-form';
import React from 'react';
import { Message } from 'primereact/message';

type Props = Omit<CalendarProps, 'value' | 'onChange'> & {
  inputName: string;
  inputLabel: string;
  containerClass?: string;
  rules?: UseControllerProps['rules'];
};

export default function DateField({ inputName, inputLabel, containerClass = '', rules, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <div className={`field ${containerClass}`}>
      <label htmlFor={inputName}>{inputLabel}</label>
      <Controller
        name={inputName}
        control={control}
        rules={rules}
        render={({ field: { onChange, value, ...field }, fieldState }) => (
          <React.Fragment>
            <Calendar
              id={inputName}
              {...field}
              value={value}
              onChange={(e) => onChange(e.value)}
              className={fieldState.error && 'p-invalid'}
              {...other}
            />
            {fieldState.error && (
              <Message id={`error-msg-${inputName}`} severity="error" text={fieldState.error?.message} />
            )}
          </React.Fragment>
        )}
      />
    </div>
  );
}
